import dayjs from "dayjs";
const createSortComparator = (valueToNumberFn: (value: string) => number) => {
  return (v1: string, v2: string): number => {
    const numericV1 = valueToNumberFn(v1);
    const numericV2 = valueToNumberFn(v2);

    return numericV1 - numericV2;
  };
};

const currencyValueToNumber = (currencyValue: string): number => {
  const numericValue = parseFloat(currencyValue.replace(/[^0-9.-]+/g, ""));
  return numericValue;
};

const valueToNumber = (value: string): number => {
  if (value === "N/A") {
    return Number.NEGATIVE_INFINITY;
  } else {
    const numericValue = parseFloat(value.replace(/[^0-9.-]+/g, ""));
    return isNaN(numericValue) ? Number.POSITIVE_INFINITY : numericValue;
  }
};

export const dateSortComparator = (date1: dayjs.Dayjs, date2: dayjs.Dayjs) => {
  return date2.unix() - date1.unix();
};
export const currencySortComparator = createSortComparator(currencyValueToNumber);
export const valueSortComparator = createSortComparator(valueToNumber);
